import { render, staticRenderFns } from "./childinfo.vue?vue&type=template&id=a4f780e4&"
import script from "./childinfo.vue?vue&type=script&lang=js&"
export * from "./childinfo.vue?vue&type=script&lang=js&"
import style0 from "./childinfo.vue?vue&type=style&index=0&id=a4f780e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports